import Signature from '@/api/signature'
import Branch from '@/api/branch'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        signature_type: attrubutes.signature_type,
        from_branch: attrubutes.from_branch
      },
      attrubutes
    )
    return Signature.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return Signature.store(data)
  },

  update(context, data) {
    return Signature.update(data)
  },

  destroy(context, id) {
    return Signature.destroy(id)
  },

  getBranch(context) {
    return Branch.get({
      params: {
        page: -1,
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        filter: {
          user_branches: true
        }
      }
    })
  }
}
